// extracted by mini-css-extract-plugin
module.exports = {"PlayingCards":"Deck_PlayingCards__1EceX","card":"Deck_card__1Se9a","deck":"Deck_deck__2pRBn"};